import { DefaultCard, PageLayout } from 'components';
import React from 'react';
import ImageAndFeatures from './ImageAndFeatures';
import Quotes from './quotes/Quotes';
import { useIsMobile, View } from 'hooks';

function PbhAboutPage() {
  const { view } = useIsMobile();
  const title = view === View.Desktop ? 'Primitive Baptist Hymnal' : 'Hymnal';
  return (
    <PageLayout>
      <DefaultCard title={title}>
        <ImageAndFeatures />
        <Quotes />
      </DefaultCard>
    </PageLayout>
  );
}

export default PbhAboutPage;
